import React, { useState } from "react";
import { Button, Menu, Stack, Box, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowDropDownIcon,
  AssessmentIcon,
  GavelIcon,
  LockIcon,
  LogoutIcon,
  PersonIcon,
  RedeemIcon,
} from "../../common/iconsData";
import styled from "styled-components";

const StyledNavLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  text-decoration: none;
  margin: 2px 10px;
  color: #0e1f2e;
  font-size: 20px;

  &:hover,
  &:active,
  &.active:link,
  &.active:visited {
    background-color: #f8fafd;
    border-radius: 10px;

    > div svg {
      color: #0e1f2e !important;
    }
  }
`;

const AvatarMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const username = localStorage.getItem("hipship-username") || "User";

  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("hipship-token");
    window.location.href = "/login";
    // navigate("/login");
  };

  return (
    <Stack>
      <Button variant="text" onClick={handleClick}>
        <PersonIcon
          sx={{
            color: "#fff",
          }}
        />
        <ArrowDropDownIcon
          sx={{
            color: "#fff",
            fontSize: "18px",
          }}
        />
      </Button>
      <Menu
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box>
          <Stack>
            <StyledNavLink to={"/dashboard"}>
              <PersonIcon fontSize="inherit" />
              <Typography fontSize={"14px"}>{username}</Typography>
            </StyledNavLink>
            <StyledNavLink to={"/dashboard"}>
              <AssessmentIcon fontSize="inherit" />
              <Typography fontSize={"14px"}>Current Plan</Typography>
            </StyledNavLink>
            <StyledNavLink to={"/dashboard"}>
              <RedeemIcon fontSize="inherit" />
              <Typography fontSize={"14px"}>Refer & Earn</Typography>
            </StyledNavLink>
            <StyledNavLink to={"/dashboard"}>
              <GavelIcon fontSize="inherit" />
              <Typography fontSize={"14px"}>Terms & Conditions</Typography>
            </StyledNavLink>
            <StyledNavLink to={"settings/change-password"}>
              <LockIcon fontSize="inherit" />
              <Typography fontSize={"14px"}>Change Password</Typography>
            </StyledNavLink>
            <StyledNavLink to={"/login"} onClick={handleLogout}>
              <LogoutIcon fontSize="inherit" />
              <Typography fontSize={"14px"}>Logout</Typography>
            </StyledNavLink>
          </Stack>
        </Box>
      </Menu>
    </Stack>
  );
};

export default AvatarMenu;
